import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 8px;

  .collapsible-header {
    background: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$dark};

    &:focus {
      box-shadow: none;
    }

    .material-icons {
      color: ${(props) => props.theme.$gray700};
    }
  }

  .collapsible-title {
    font-size: 18px;
  }
`;
